import React, { useState, useEffect } from 'react';
import { FaEnvelope, FaCheck, FaExclamationTriangle, FaInfoCircle, FaPaperPlane } from 'react-icons/fa';
import formService from '../services/formService';

const EmailSystemStatus = () => {
  const [emailStatus, setEmailStatus] = useState('checking');
  const [lastTestResult, setLastTestResult] = useState(null);

  useEffect(() => {
    testEmailSystem();
  }, []);

  const testEmailSystem = async () => {
    try {
      setEmailStatus('checking');
      // Test with a dummy email to check if the system is working
      const result = await formService.testEmail('test@droshpod.com');
      setEmailStatus('working');
      setLastTestResult(result);
    } catch (error) {
      setEmailStatus('error');
      setLastTestResult({ error: error.message });
    }
  };

  const getStatusIcon = () => {
    switch (emailStatus) {
      case 'working':
        return <FaCheck className="text-green-600" />;
      case 'error':
        return <FaExclamationTriangle className="text-red-600" />;
      case 'checking':
        return <FaEnvelope className="text-blue-600 animate-pulse" />;
      default:
        return <FaInfoCircle className="text-gray-600" />;
    }
  };

  const getStatusMessage = () => {
    switch (emailStatus) {
      case 'working':
        return 'Email system is working correctly';
      case 'error':
        return 'Email system has issues - check configuration';
      case 'checking':
        return 'Checking email system status...';
      default:
        return 'Email system status unknown';
    }
  };

  const getStatusColor = () => {
    switch (emailStatus) {
      case 'working':
        return 'bg-green-50 border-green-200 text-green-800';
      case 'error':
        return 'bg-red-50 border-red-200 text-red-800';
      case 'checking':
        return 'bg-blue-50 border-blue-200 text-blue-800';
      default:
        return 'bg-gray-50 border-gray-200 text-gray-800';
    }
  };

  return (
    <div className={`${getStatusColor()} border rounded-lg p-4 mb-6`}>
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="flex-shrink-0 mr-3">
            {emailStatus === 'checking' ? (
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-blue-600"></div>
            ) : (
              getStatusIcon()
            )}
          </div>
          <div>
            <h3 className="font-semibold text-sm">Email System Status</h3>
            <p className="text-sm opacity-90">{getStatusMessage()}</p>
            {lastTestResult && emailStatus === 'working' && (
              <p className="text-xs opacity-75 mt-1">
                Last test: {new Date().toLocaleTimeString()}
              </p>
            )}
          </div>
        </div>
        <button
          onClick={testEmailSystem}
          disabled={emailStatus === 'checking'}
          className="px-3 py-1 text-xs bg-white bg-opacity-50 hover:bg-opacity-75 rounded transition-colors disabled:opacity-50"
        >
          <FaPaperPlane className="inline mr-1" />
          Test
        </button>
      </div>
    </div>
  );
};

export default EmailSystemStatus;
